<template>
  <div>
    <div class="boss-layout boss-layout-start">
      <div class="boss-layout-item-no-shrink">
        <span
          class="boss-button boss-button-compact"
          data-test="button"
          @click="openReveal"
        >{{ buttonLabel }}</span>
      </div>
      <div
        data-test="label"
        :class="{ 'pega-ellipsis': isEllipsis }"
      >
        {{ checkedLabel }}
      </div>
    </div>
    <!-- ▼モーダルウィンドウ -->
    <div
      :id="'boss-modal-select-control-'+suffix"
      class="large reveal boss-modal-container"
      style="height:100%"
      data-reveal
    >
      <h2
        class="boss-title"
        data-test="title"
      >
        {{ title }}選択
      </h2>
      <div style="max-height:90%; overflow:auto;">
        <div class="boss-modal-form clearfix">
          <select-modal-tab-menu
            v-if="showTabMenu"
            :master-data-map="masterDataMap"
            :master-data="convertedMasterData"
            :suffix="suffix"
            :depth="depth"
          />
          <select-modal-contents
            :master-data-map="masterDataMap"
            :master-data="convertedMasterData"
            :suffix="suffix"
            :depth="depth"
            :experience-range-options="experienceRangeOptions"
            :default-experience-id="defaultExperienceId"
            :can-accordion="canAccordion"
            @update-master-data-map="updateMasterDataMap"
          />
        </div>
      </div>
      <!-- ▼☓ボタン -->
      <button
        class="close-button boss-close-button boss-icon-cross"
        data-close
        aria-label="Close modal"
        type="button"
        data-test="cancel"
        @click="cancel"
      />
      <!-- ▲☓ボタン -->
      <!-- ▼設定を閉じるボタン -->
      <div class="boss-modal-close">
        <button
          class="float-center boss-button-center boss-button-large boss-modal-close-button"
          data-close
          aria-label="Close modal"
          type="button"
          data-test="save"
          @click="save"
        >
          設定して閉じる
        </button>
      </div>
      <!-- ▲設定を閉じるボタン -->
    </div>
    <!-- ▲モーダルウィンドウ -->
  </div>
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import SelectModalTabMenu from '@/components/molecules/SelectModalTabMenu'
import SelectModalContents from '@/components/molecules/SelectModalContents'

export default {
  components: {
    SelectModalTabMenu,
    SelectModalContents
  },
  props: {
    title: {
      type: String,
      required: true
    },
    suffix: {
      type: String,
      required: true
    },
    masterData: {
      type: Array,
      required: true
    },
    experienceRangeOptions: {
      type: Array,
      default: () => ([])
    },
    selectedItems: {
      type: Array,
      default: () => ([])
    },
    buttonLabel: {
      type: String,
      default: '編集する'
    },
    defaultExperienceId: {
      type: String,
      default: ''
    },
    isWrapCategory: {
      type: Boolean,
      default: false
    },
    isEllipsis: {
      type: Boolean,
      default: false
    },
    canAccordion: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      masterDataMap: null,
      savedMasterDataMap: null, // キャンセル時、編集前の状態に戻すために保管
      selectedCategoryItems: []
    }
  },
  computed: {
    checkedLabel () {
      if (this.hasCategory && this.isWrapCategory) {
        // カテゴリでラップする場合（※experience非対応）
        return this.selectedCategoryItems.map(item => {
          if (item.isCheckAll) {
            return item.name
          } else {
            return `${item.name}（${item.children.map(child => child.name).join('、')}）`
          }
        }).join('、')
      } else {
        // それ以外
        return this.selectedCategoryItems.map(item => {
          if (this.experienceRangeOptions.length > 0) {
            return `${item.name}[${this.experienceRangeOptions.find(option => String(option.id) === String(item.experience)).name}]`
          } else {
            return item.name
          }
        }).join('、')
      }
    },
    showTabMenu () {
      return this.depth > 1
    },
    hasCategory () {
      return this.depth > 2
    },
    depth () {
      if (!Object.prototype.hasOwnProperty.call(this.masterData[0], 'children')) {
        return 1
      }
      if (!Object.prototype.hasOwnProperty.call(this.masterData[0].children[0], 'children')) {
        return 2
      }
      if (!Object.prototype.hasOwnProperty.call(this.masterData[0].children[0].children[0], 'children')) {
        return 3
      }
      if (!Object.prototype.hasOwnProperty.call(this.masterData[0].children[0].children[0].children[0], 'children')) {
        return 4
      }
      return 0
    },
    convertedMasterData () {
      if (!this.showTabMenu) {
        // 1階層のデータは擬似的に2階層に変換する
        // （擬似的な2階層にすることで、MasterDataの形を変更せず、子コンポーネントを利用できるようにしている）
        // UIは、tabMenuが表示されず（showTabMenu）、コンテンツのエリアのみ表示される
        return [{ id: 999, name: 'dummy', children: this.masterData }]
      } else {
        return this.masterData
      }
    }
  },
  created () {
    this.masterDataMap = this.createMasterDataMap()
    this.save()
  },
  mounted () {
    this.modalSelect = new Foundation.Reveal(jQuery('#boss-modal-select-control-' + this.suffix), {
      closeOnClick: false
    })
  },
  beforeDestroy () {
    jQuery('.reveal-overlay').remove()
  },
  methods: {
    updateMasterDataMap (masterDataMap) {
      this.masterDataMap = masterDataMap
    },
    openReveal () {
      this.modalSelect.open()
    },
    save () {
      this.savedMasterDataMap = { ...this.masterDataMap }
      // dataは表示に合わせた階層構造を持ったデータなので、フラットな構造にしつつ文字列の配列に変換する
      if (this.hasCategory) {
        if (this.isWrapCategory) { // カテゴリ名でラップする場合
          this.selectedCategoryItems = this.convertedMasterData.flatMap(categories =>
            categories.children.filter(category => category.children.some(j => this.masterDataMap[categories.id][category.id][j.id].check))
              .flatMap(category => {
                const isCheckAll = category.children.every(j => this.masterDataMap[categories.id][category.id][j.id].check)
                return {
                  id: category.id,
                  name: category.name,
                  isCheckAll: isCheckAll,
                  children: isCheckAll ? [] : category.children.filter(categoryItem => this.masterDataMap[categories.id][category.id][categoryItem.id].check)
                    .map(categoryItem => {
                      const experience = this.masterDataMap[categories.id][category.id][categoryItem.id].experience
                      return { id: categoryItem.id, name: categoryItem.name, experience: experience || this.defaultExperienceId }
                    })
                }
              })
          )
        } else {
          this.selectedCategoryItems = this.convertedMasterData.flatMap(categories =>
            categories.children.flatMap(category =>
              category.children.filter(categoryItem =>
                this.masterDataMap[categories.id][category.id][categoryItem.id].check
              ).map(categoryItem => {
                const experience = this.masterDataMap[categories.id][category.id][categoryItem.id].experience
                return { id: categoryItem.id, name: categoryItem.name, experience: experience || this.defaultExperienceId }
              })
            )
          )
        }
      } else {
        this.selectedCategoryItems = this.convertedMasterData.flatMap(categories =>
          categories.children.filter(categoryItem =>
            this.masterDataMap[categories.id][categoryItem.id].check
          ).map(categoryItem => {
            const experience = this.masterDataMap[categories.id][categoryItem.id].experience
            return { id: categoryItem.id, name: categoryItem.name, experience: experience }
          })
        )
      }
      this.$emit('update-modal-checked-ids', this.selectedCategoryItems)
    },
    cancel () {
      this.masterDataMap = { ...this.savedMasterDataMap }
    },
    createMasterDataMap () {
      if (this.hasCategory) {
        return this.convertedMasterData.reduce((acc, currentMasterLv1) => (
          {
            ...acc,
            [currentMasterLv1.id]: currentMasterLv1.children.reduce((acc, currentMasterLv2) => {
              const currentMasterLv2Id = currentMasterLv2.id
              return {
                ...acc,
                [currentMasterLv2.id]: currentMasterLv2.children.reduce((acc, currentMasterLv3) => {
                  const item = this.selectedItems.find(x => x.id === currentMasterLv2Id || x.id === currentMasterLv3.id)
                  if (item) {
                    return { ...acc, [currentMasterLv3.id]: { check: true, experience: item.experience } }
                  } else {
                    return { ...acc, [currentMasterLv3.id]: { check: false, experience: '' } }
                  }
                }, {})
              }
            }, {})
          }
        ), {})
        // 3階層で生成 例：{ 1: { 2: { 3: { check: false, experience: '' } } } }
      } else {
        return this.convertedMasterData.reduce((acc, currentMasterLv1) => (
          {
            ...acc,
            [currentMasterLv1.id]: currentMasterLv1.children.reduce((acc, currentMasterLv2) => {
              const item = this.selectedItems.find(x => x.id === currentMasterLv2.id)
              if (item) {
                return { ...acc, [currentMasterLv2.id]: { check: true, experience: item.experience } }
              } else {
                return { ...acc, [currentMasterLv2.id]: { check: false, experience: '' } }
              }
            }, {})
          }
        ), {})
        // 2階層で生成 例：{ 1: { 2: { check: false, experience: '' } } }
      }
    }
  }
}
</script>
